<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	// import Escort from './components/Escort.vue'
	// import WholeMachineTest from './components/BigScreen/BigScreen.vue'
	export default {
		name: 'app',
		components: {
			// WholeMachineTest,
			// Escort
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: #2c3e50;
		width: 100%;
		height: 100%;
	}
	html {
		font-size: 16px !important;
	}
</style>
